export { WaitTelegramChatsModule } from './wait-telegram-chats.module';
